var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.wrapClasses, staticStyle: { "touch-action": "none" } },
    [
      _c(
        "div",
        {
          ref: "scrollContainer",
          class: _vm.scrollContainerClasses,
          style: { height: _vm.height + "px" },
          on: {
            scroll: _vm.handleScroll,
            wheel: _vm.onWheel,
            touchstart: _vm.onPointerDown
          }
        },
        [
          _c(
            "div",
            {
              ref: "toploader",
              class: _vm.loaderClasses,
              style: { paddingTop: _vm.wrapperPadding.paddingTop }
            },
            [
              _c("loader", {
                attrs: {
                  text: _vm.localeLoadingText,
                  active: _vm.showTopLoader
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { ref: "scrollContent", class: _vm.slotContainerClasses },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "bottomLoader",
              class: _vm.loaderClasses,
              style: { paddingBottom: _vm.wrapperPadding.paddingBottom }
            },
            [
              _c("loader", {
                attrs: {
                  text: _vm.localeLoadingText,
                  active: _vm.showBottomLoader
                }
              })
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ca4dcb6", { render: render, staticRenderFns: staticRenderFns })
  }
}